/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { QueuedRelease } from '../models/queued-release';

/**
 * Ui Queued Release Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiQueuedReleaseControllerService extends __BaseService {
  static readonly getAllQueuedReleasesUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/queued-releases/';
  static readonly deleteByIdUsingDELETEPath =
    '/cc-ui/v1/clusters/{clusterId}/queued-releases/{queuedReleaseId}';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAllQueuedReleases
   * @param clusterId clusterId
   * @return OK
   */
  getAllQueuedReleasesUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<Array<QueuedRelease>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/queued-releases/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<QueuedRelease>>;
      }),
    );
  }
  /**
   * getAllQueuedReleases
   * @param clusterId clusterId
   * @return OK
   */
  getAllQueuedReleasesUsingGET(
    clusterId: string,
  ): __Observable<Array<QueuedRelease>> {
    return this.getAllQueuedReleasesUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as Array<QueuedRelease>),
    );
  }

  /**
   * deleteById
   * @param params The `UiQueuedReleaseControllerService.DeleteByIdUsingDELETEParams` containing the following parameters:
   *
   * - `queuedReleaseId`: queuedReleaseId
   *
   * - `clusterId`: clusterId
   */
  deleteByIdUsingDELETEResponse(
    params: UiQueuedReleaseControllerService.DeleteByIdUsingDELETEParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/queued-releases/${encodeURIComponent(
          String(params.queuedReleaseId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * deleteById
   * @param params The `UiQueuedReleaseControllerService.DeleteByIdUsingDELETEParams` containing the following parameters:
   *
   * - `queuedReleaseId`: queuedReleaseId
   *
   * - `clusterId`: clusterId
   */
  deleteByIdUsingDELETE(
    params: UiQueuedReleaseControllerService.DeleteByIdUsingDELETEParams,
  ): __Observable<null> {
    return this.deleteByIdUsingDELETEResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }
}

module UiQueuedReleaseControllerService {
  /**
   * Parameters for deleteByIdUsingDELETE
   */
  export interface DeleteByIdUsingDELETEParams {
    /**
     * queuedReleaseId
     */
    queuedReleaseId: string;

    /**
     * clusterId
     */
    clusterId: string;
  }
}

export { UiQueuedReleaseControllerService };
